import * as yup from 'yup';

export const client_classification_schema = {
  clientClassificationAnyEntityCriterias: [],
  clientClassificationAnyLegalPersonCriterias: [],
  others_Specify: '',
};

export const client_classification_validation_schema = yup.object().shape({
  clientClassificationAnyEntityCriterias: yup
    .array()
    .required('entity_criteria_required')
    .min(1, 'min_entity_criteria'),
  clientClassificationAnyLegalPersonCriterias: yup
    .array()
    .required('legal_person_criteria_required')
    .min(1, 'min_entity_criteria'),
  othersPleaseSpecify: yup.string().required('other_please_specify_required'),
});
